import { forwardRef } from 'react';
import { MiniLoader } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

export const Loading = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <Root {...props} ref={ref}>
      <MiniLoader />
    </Root>
  );
});

export const Root = styled.div`
  display: flex;
  overflow: visible;
  justify-content: center;
  align-items: center;
  height: 32px;
`;
